<div id="adding-area">
  <div id="adding-area-container">
    <div id="adding-area-content" class="border-like-dx" [class.collapsed]="isAddAreaCollapsed()">

      <div class="line">
        <yo-tagbox
          [data]="pointFacturationList()"
          [selectedItems]="selectedPointFacturationIdList()"
          key="id"
          displayValue="libelle"
          placeholder="Sélectionner un ou plusieurs points de facturation..."
          (onValueChange)="onPointFacturationIdListChange($event)">
        </yo-tagbox>

        <yo-tagbox
          [data]="plcList()"
          [selectedItems]="selectedPlcIdList()"
          key="id"
          displayValue="libelle"
          placeholder="Sélectionner un ou plusieurs points de livraison..."
          [disabled]="!selectedPointFacturationIdList().length"
          (onValueChange)="onPlcIdListChange($event)">
        </yo-tagbox>

        <yo-tagbox
          [data]="produitComplementaireList()"
          [selectedItems]="selectedProduitComplementaireIdList()"
          key="produitDeclinaisonId"
          displayValue="libelle"
          placeholder="Sélectionner un ou plusieurs produits complémentaires..."
          [disabled]="!selectedPlcIdList().length"
          (onValueChange)="onProduitComplementaireIdListChange($event)">
        </yo-tagbox>
      </div>

      <div class="line custom-button-container-right">
        <yo-button
          iconClass="fa fa-save"
          label="Ajouter"
          tooltip="Ajouter les lignes de paramétrage"
          [theme]="ButtonThemeEnum.SAVE"
          [disabled]="!isReadyToAdd()"
          (onClick)="addLignesParametrage()">
        </yo-button>
        <yo-button
          iconClass="fa fa-times"
          label="Fermer"
          tooltip="Réduire la zone d'ajout de lignes de paramétrage"
          [theme]="ButtonThemeEnum.CANCEL"
          (onClick)="closeAddArea()">
        </yo-button>
      </div>

    </div>
  </div>
</div>

<dx-popup
  title="Paramétrage des lignes à créer/modifier"
  [visible]="isStagingPopupVisible()"
  width="1200"
  height="auto"
  maxHeight="80vh"
  minWidth="600"
  [resizeEnabled]="true"
  (onHiding)="closeStagingPopup()">
  <div class="full-size">
    <yo-ligne-parametrage-produit-complementaire-data-grid
      #gridPopup
      class="grid-container"
      [lignes]="stagingList()"
      (periodeBadgeClick)="onPeriodeBadgeClick('staging', $event)"
      (taxeCellClick)="onTaxeCellClick('staging', $event)">
      <div data-position="right" class="custom-button-container">
        <yo-button
          [theme]="ButtonThemeEnum.DEFAULT"
          tooltip="Modifier la taxe des lignes sélectionnées"
          iconClass="fa fa-edit"
          [disabled]="!isPopupRowSelected()"
          (onClick)="openModificationPopup('staging')">
        </yo-button>
        <yo-button
          [theme]="ButtonThemeEnum.DEFAULT"
          tooltip="Modifier les périodes de prix"
          iconClass="fa fa-calendar"
          [disabled]="!isPopupRowSelected()"
          (onClick)="openPeriodePrixPopup('staging')">
        </yo-button>
        <yo-button
          [theme]="ButtonThemeEnum.SAVE"
          iconClass="fa fa-save"
          [tooltip]="stagingSaveTooltip()"
          [disabled]="!isReadyToSaveStaging()"
          (onClick)="saveStagingList()">
        </yo-button>
        <yo-button
          [theme]="ButtonThemeEnum.DELETE_INNER"
          iconClass="fa fa-trash"
          tooltip="Supprimer les lignes de paramétrage sélectionnées"
          [disabled]="!isPopupRowSelected()"
          (onClick)="deleteSelected('staging')">
        </yo-button>
      </div>
    </yo-ligne-parametrage-produit-complementaire-data-grid>
  </div>
</dx-popup>

<dx-popup
  title="Modification de masse"
  [visible]="isModificationPopupDisplayed()"
  width="auto"
  height="auto"
  minWidth="600"
  (onHiding)="closeModificationPopup()">
  <div class="dialog-line">
    <div class="label">Taxe</div>
    <div class="value">
      <yo-lookup
        [data]="taxeList()"
        [selectedItem]="selectedTaxeIdForModification()"
        [autoSelect]="false"
        (onValueChange)="selectedTaxeIdForModification.set($event)"
        placeholder="Sélectionner la taxe ...">
      </yo-lookup>
    </div>
  </div>
  <div class="dialog-line">
    <div class="custom-button-container-right">
      <yo-button
        [theme]="ButtonThemeEnum.SAVE"
        iconClass="fa fa-check"
        (onClick)="applyModification()">
      </yo-button>
    </div>
  </div>
</dx-popup>

<dx-popup
  title="Période de prix"
  [visible]="isPeriodePrixPopupDisplayed()"
  width="auto"
  height="auto"
  minWidth="600"
  (onHiding)="closePeriodePrixPopup()">
  <div class="dialog-line">
    <div class="label">Prix de vente HT</div>
    <div class="value">
      <dx-number-box
        [value]="selectedPrixForPeriode()"
        (onValueChanged)="selectedPrixForPeriode.set($event.value)"
        placeholder="Prix de vente HT">
      </dx-number-box>
    </div>
  </div>
  <div class="dialog-line">
    <div class="label">Taux de revalorisation</div>
    <div class="value">
      <dx-number-box
        [value]="selectedTauxForPeriode()"
        (onValueChanged)="selectedTauxForPeriode.set($event.value)"
        placeholder="Taux en %">
      </dx-number-box>
    </div>
  </div>
  <div class="dialog-line">
    <div class="label">
      <span>A partir de</span>
    </div>
    <div class="value">
      <yo-date-picker
        [value]="selectedDateForPeriode()"
        (onValueChange)="selectedDateForPeriode.set($event)">
      </yo-date-picker>
    </div>
  </div>
  <div class="dialog-line">
    <div class="custom-button-container-right">
      <yo-button
        [theme]="ButtonThemeEnum.SAVE"
        iconClass="fa fa-check"
        (onClick)="applyPeriodePrix()">
      </yo-button>
    </div>
  </div>
</dx-popup>

<yo-ligne-parametrage-produit-complementaire-data-grid
  #gridMain
  class="grid-container"
  [lignes]="ligneParametrageList()"
  (periodeBadgeClick)="onPeriodeBadgeClick('main', $event)"
  (taxeCellClick)="onTaxeCellClick('main', $event)">
  <div data-position="left">
    <yo-button
      [theme]="ButtonThemeEnum.DEFAULT"
      iconClass="fa fa-plus"
      label="CRÉER"
      tooltip="Créer un nouveau paramétrage"
      (onClick)="openAddArea()">
    </yo-button>
  </div>
  <div data-position="right" class="custom-button-container">
    <yo-button
      [theme]="ButtonThemeEnum.DEFAULT"
      tooltip="Modifier la taxe des lignes sélectionnées"
      iconClass="fa fa-edit"
      [disabled]="!isMainRowSelected()"
      (onClick)="openModificationPopup('main')">
    </yo-button>
    <yo-button
      [theme]="ButtonThemeEnum.DEFAULT"
      tooltip="Modifier les périodes de prix"
      iconClass="fa fa-calendar"
      [disabled]="!isMainRowSelected()"
      (onClick)="openPeriodePrixPopup('main')">
    </yo-button>
    <yo-button
      [theme]="ButtonThemeEnum.SAVE"
      iconClass="fa fa-save"
      tooltip="Enregistrer les lignes de paramétrage"
      [disabled]="!hasMainChanges()"
      (onClick)="saveMainChanges()">
    </yo-button>
    <yo-button
      [theme]="ButtonThemeEnum.DELETE_INNER"
      iconClass="fa fa-trash"
      tooltip="Supprimer les lignes de paramétrage sélectionnées"
      [disabled]="!isMainRowSelected()"
      (onClick)="deleteSelected('main')">
    </yo-button>
    <yo-button
      [theme]="ButtonThemeEnum.DELETE_INNER"
      iconClass="fa fa-broom"
      tooltip="Supprimer les périodes obsolètes"
      [disabled]="!hasObsoletePeriodes()"
      (onClick)="cleanObsoletePeriodes()">
    </yo-button>
  </div>
</yo-ligne-parametrage-produit-complementaire-data-grid>
